// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.
/**
 * Models for spaces operations
 */
import type * as Schemas from '../schemas.js';





/**
 * Response for getByIds
 * 
 * @public
 */
export type GetByIdsResponse = Schemas.Get2SpacesResponse;
/**
 * Response for getBuyers
 * 
 * @public
 */
export type GetBuyersResponse = Schemas.Get2SpacesIdBuyersResponse;
/**
 * Response for getPosts
 * 
 * @public
 */
export type GetPostsResponse = Schemas.Get2SpacesIdTweetsResponse;
/**
 * Response for search
 * 
 * @public
 */
export type SearchResponse = Schemas.Get2SpacesSearchResponse;
/**
 * Response for getById
 * 
 * @public
 */
export type GetByIdResponse = Schemas.Get2SpacesIdResponse;
/**
 * Response for getByCreatorIds
 * 
 * @public
 */
export type GetByCreatorIdsResponse = Schemas.Get2SpacesByCreatorIdsResponse;